export interface IndicatorScoreModel {
  categoryName: string;
  categoryType: number;
  index: number;
  quadrant: number;
  score: number;
}
